export default __webpack_public_path__ + "static/media/semiGrandExam.753acc75.png";